<template>
    <div>
        <b-card>
            <div slot="header">
                <strong>PDA Management</strong>
                <div class="card-header-actions" v-if="this.user_type=='2'">
                    <b-button variant="primary" @click="redirectTOaddpda()" size="sm" :disabled="isReadOnly">ADD PDA / Issues</b-button>
                </div>
            </div>
            <div>
                <b-row>
                    <b-col md="12">
                        <ul class="nav nav-tabs nav-justified">
                            <li class="nav-item">
                                <a class="nav-link" @click="activeTab = 0" :class="{'active': isActiveTab(0)}">Allocated PDA</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" @click="activeTab = 1" :class="{'active' : isActiveTab(1)}">Handover PDA</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" @click="activeTab = 2" :class="{'active' : isActiveTab(2)}">Search PDA</a>
                            </li>
                        </ul>
                    </b-col>
                </b-row>
            </div>

            <div>
                <b-row>
                    <b-col md="12">
                        <div class="tab-panel" v-if="isActiveTab(0)">
                            <PDA_Allocated></PDA_Allocated>
                        </div>
                        <div class="tab-panel" v-if="isActiveTab(1)">
                            <PDA_Handover></PDA_Handover>
                        </div>
                        <div class="tab-panel" v-if="isActiveTab(2)">
                            <PDA_Search></PDA_Search>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
import PDA_Allocated from './PDA_Allocated.vue'
import PDA_Handover from './PDA_Handover.vue'
import PDA_Search from './PDA_Search.vue'
export default {
    data() {
        return {
            activeTab:0,
            user_type:'',
            accessBody:[],
            isReadOnly:false,
        }
    },

    components : {
        PDA_Allocated,
        PDA_Handover,
        PDA_Search
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.user_type=userInfo.user_type;
        this.accessBody = userInfo.body;
        this.ischeckbodyvalidation();
        this.isActiveTab(0);

    },

    methods: {
        ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=='PDA Configuration' && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='PDA Configuration' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
        isActiveTab(id){
            return this.activeTab === id
        },

        redirectTOaddpda(){
            this.$router.push('/PDA_Add')
        }
    }
}
</script>